module.exports = __webpack_public_path__ + "static/media/xueshan3.9153da6c.jpg";